<template>
  <div>
    <div class="page-title">New Entry</div>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Entry" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.lists-entries.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ListEntry.new({
        list_id: this.$route.params.listId,
      });
      this.form = data;
    },
    async create() {
      await this.$api.ListEntry.create(this.form);
      this.$router.push("/widgets/lists");
    },
  },
};
</script>

<style></style>
